import React, { memo } from 'react';

import { withScreenSize } from '../../../common/utilities/withScreenSize.jsx';
import { LargeHourCardListItemsLoadingUI } from './destopTabletViews/largeHourCardListItemsLoadingUI';
import { MobileHourCardListItemsLoadingUI } from './mobileViews/mobileHourCardListItemsLoadingUI';

interface HouryForecastViewLoadingUIProps {
    isMobile: boolean;
}

export const HouryForecastViewLoadingUI = withScreenSize(memo(({ isMobile }: HouryForecastViewLoadingUIProps) => {
    return isMobile ?  <MobileHourCardListItemsLoadingUI /> : <LargeHourCardListItemsLoadingUI />;
}));

